/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function fadeOutEffect() {
 this.classList.add("item-effect");
}
function fadeinEffect() {
 this.classList.remove("item-effect");
}
// var comment = document.getElementsByClassName("featured_media-image");

// for (var i = 0 ; i < comment.length; i++) {
//    comment[i].addEventListener('touchstart' , fadeOutEffect);   
//    }  
// for (var i = 0 ; i < comment.length; i++) {
//    comment[i].addEventListener('touchend' , fadeinEffect);   
//    }


/*----------------(16/12)------------------*/
// $(window).on('load',function(){
//   var check = $('.itg.ProductForm__Item').val();
//   $('button.Popover__Value[data-value="'+check+'"]').trigger('click');

//   $('.itg.ProductForm__Item').change(function(){
//       var check = $(this).val();  
//      $('button.Popover__Value[data-value="'+check+'"]').trigger('click');
//   });    
// })

$(document).on('click touch', '.selection span.custom_selector_list_title', function(){
  $(this).parents('.selection').find('span.vaiant_selector_container').addClass('active');
 //$(this).next('span.vaiant_selector_container').addClass('active').siblings().removeClass('active');
});

//const $menu = $('.vaiant_selector_container')

const onMouseUp = e => {
 if (!$menu.is(e.target) // If the target of the click isn't the container...
   && $menu.has(e.target).length === 0) // ... or a descendant of the container.
   {
     $menu.removeClass('active')
  }
}

$('.selection span.custom_selector_list_title').on('click', () => {
  $menu.toggleClass('active').promise().done(() => {
    if ($menu.hasClass('active')) {
      $(document).on('mouseup', onMouseUp) // Only listen for mouseup when menu is active...
    } else {
      $(document).off('mouseup', onMouseUp) // else remove listener.
    }
  })
})

$(document).on('click touch', '.custom_selector_list', function(){
  $(this).parents('.selection').find('span.vaiant_selector_container').removeClass('active');
});


$(document).on('click', '.custom_selector_list', function(){
    var inputVal = $(this).attr('value');
    var stockText = $(this).find('.stock_label').text();
    $(this).parents('.selection').find('span.value_name').text(inputVal);
     $(this).parents('.selection').find('span.instock_label').text(stockText);

    var this_ = this.closest(".ProductForm__Option");
    var select = this_.querySelector('.itg.ProductForm__Item');
    select.addEventListener('change',function(){});
    select.value = inputVal;
    select.dispatchEvent(new Event('change'));

    let var_qty = $(this).closest('.custom_variant_selector').find('.custom_selector_list').data('qty');
    if(parseInt(var_qty) === 0){
        $('.ProductForm__AddToCart').prop('disabled', true);
        $('.ProductForm__AddToCart span').text('SOLD OUT');
    } else {
        $('.ProductForm__AddToCart').prop('disabled', false);
        $('.ProductForm__AddToCart span').text('Add to cart');
    }

  
});


$(document).ready(function(){
  $('.stock_label_msg').hide();
  $(document).on('click', '.custom_selector_list', function(){
   var varQty = $(this).data('qty');
   $('.remain_qty').text(varQty);
   if(varQty > 0 && varQty < 5){
      $('.stock_label_msg').show();
   }else{
     $('.stock_label_msg').hide();
   }
});
})


  // var select = document.querySelector('.itg.ProductForm__Item'),
  // input = document.querySelector('.Header__Wrapper');
  // select.addEventListener('change',function(){
  //   alert('changed');
  // });
  // input.addEventListener('click',function(){
  //   select.value = "10' x 14'";
  //   select.dispatchEvent(new Event('change'));
  // });



function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};




$(document).on('change','.add-to-cart-form input[type="radio"]',function () {
   var VariantsID = $(this).data("variantid");
  var shopMoney = $(document).find('.ProductMeta__Title').data('money');
  var firstVal = $('.add-to-cart-form .custom_variant_selector[data-option-index="0"] input[type="radio"]:checked').val();
  var secondVal = $('.add-to-cart-form .custom_variant_selector[data-option-index="1"] input[type="radio"]:checked').val();
  var thirdVal = $('.add-to-cart-form .custom_variant_selector[data-option-index="2"] input[type="radio"]:checked').val();
  var mainVal = null;

  if($('.add-to-cart-form .custom_variant_selector[data-option-index="2"]').length){
    mainVal = firstVal +' / '+ secondVal +' / '+ thirdVal;
  } else if($('.add-to-cart-form .custom_variant_selector[data-option-index="1"]').length){
    mainVal = firstVal +' / '+ secondVal;
  }else{
    mainVal = firstVal;
  }
  //console.log(mainVal);
  $('.ProductForm__Option select[name="id"] option').each(function(){
    var variantsIDS = $(this).val();
    if(VariantsID == variantsIDS){
           var proPrice = $(this).data('price');
      $(document).find('.ProductMeta__Price').html(formatMoney(proPrice, shopMoney));
    }
    var optVal = $(this).text().trim();

    if(optVal == mainVal){
      console.log(optVal +'--'+ mainVal)
      $(this).prop('selected',true);
       var proPrice = $(this).data('price');
      $(document).find('.ProductMeta__Price').html(formatMoney(proPrice, shopMoney));
      
     var varQty =  $(this).data('qty');
      if(varQty > 0){
        $(document).find('.ProductForm__AddToCart').attr('disabled',false);
      }else{
        $(document).find('.ProductForm__AddToCart').attr('disabled',true);
        $(document).find('.ProductForm__AddToCart > span').text('SOLD OUT');
      }
    }else{
      $(this).prop('selected',false);
    }
  });
});




